import { Directive } from '@angular/core';
@Directive({ selector: 'time'})
export class TimeDirective {}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/utils/time.directive.ts